// import { cva } from 'class-variance-authority'
// import { cn } from '~/lib/utils'

interface BrowserProps {
  children: React.ReactNode
  // padding?: 'Large Alt' | 'Small Alt' | 'Large' | 'Small' | null | undefined
  config?: {
    sectionName: string
    // contained?: boolean
  }
}

// const section = cva(
//   'gap-l grid min-h-[80px] w-full grid-flow-row grid-cols-1',
//   {
//     variants: {
//       colour: {
//         'ink-blue': 'bg-blue-d text-white',
//         'mid-blue': 'bg-blue-m text-white',
//         'light-blue': 'bg-blue-l text-blue-d',
//         chartreuse: 'bg-char text-blue-d',
//         'light-purple': 'bg-purple text-blue-d',
//         'light-pink': 'bg-pink text-blue-d',
//         'light-aqua': 'bg-aqua text-blue-d',
//         'light-orange': 'bg-orange text-blue-d',
//         'light-grey': 'bg-grey-l text-blue-d dark:bg-black dark:text-white',
//         white: 'bg-white dark:bg-black'
//       },
//       columns: {
//         default: 'lg:grid-cols-3',
//         golden: 'md:grid-cols-2 lg:grid-cols-3',
//         halves: 'md:grid-cols-2',
//         full: 'md:grid-cols-1'
//       },
//       padding: {
//         'Large Alt': 'pb-[120px]',
//         'Small Alt': 'pb-[80px] pt-[40px]',
//         Large: 'py-[120px]',
//         Small: 'py-[80px]'
//       }
//     },
//     defaultVariants: {
//       colour: 'white',
//       columns: 'default',
//       padding: 'Small'
//     }
//   }
// )

const Browser = (props: BrowserProps) => {
  const { children, config } = props

  return (
    <section
      aria-label={config?.sectionName}
      // className={cn(
      //   section({
      //     padding: padding,
      //   })
      // )}
    >
      {/* <div className={cn(config?.contained ? 'container' : '')}>{children}</div> */}
      {children}
    </section>
  )
}

export default Browser
